export default __webpack_public_path__ + "static/media/perlingo-buttonn.3d74558f.gif";